import {React, useEffect} from 'react';
import {HashRouter,Route,Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from "framer-motion";
import ScrollToTop  from './components/ScrollToTop';
import Nav from './components/Nav';
import Home from './components/Home';
import Work from './components/Work';
import About from './components/About';
import Contact from './components/Contact';
import Social from './components/Social';
import Footer from './components/Footer';
import ScrollDown from './components/ScrollDown';
import HeartScene from "./components/HeartScene";
import ReactGA from 'react-ga';


import TEEsim from './components/TEEsim';
import CPRassist from './components/CPRassist';
import HErectus from './components/h_erectus';
import DeathZone from './components/DeathZone';
import Endocarditis from './components/Endocarditis';
import MediapipeNeuro from './components/MediapipeNeuro';
import SelfEcorche from './components/SelfEcorche';
import MiscMedical from './components/MiscMedical';
import SciRobotics from './components/SciRobotics';
import MedIllus from './components/MedIllus';
import './style.scss';



const Animated = () => {
  const location = useLocation();


  useEffect(() => {    

    ReactGA.initialize('UA-193206324-2');

    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);


  useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }, [location]);
  
  return (
      <AnimatePresence exitBeforeEnter initial={false} >
            <ScrollToTop />

<Routes location={location} 
              key={location.pathname}>


                
  <Route exact path="/" element={<Home />} />
  <Route path="/work" element={<Work />} />
  <Route path="/about" element={<About />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/work/TEEsim" element={<TEEsim />} />
  <Route path="/work/CPRassist" element={<CPRassist />} />
  <Route path="/work/HErectus" element={<HErectus />} />
  <Route path="/work/DeathZone" element={<DeathZone />} />
  <Route path="/work/Endocarditis" element={<Endocarditis />} />
  <Route path="/work/MediapipeNeuro" element={<MediapipeNeuro />} />
  <Route path="/work/SelfEcorche" element={<SelfEcorche />} />
  <Route path="/work/MiscMedical" element={<MiscMedical />} />
  <Route path="/work/SciRobotics" element={<SciRobotics />} />
  <Route path="/work/MedIllus" element={<MedIllus />} />
  </Routes>
          {/* <Switch location={location} 
              key={location.pathname}>
              <Route exact path="/" component={Home}></Route>
              <Route exact path="/work" component={Work}></Route>

              <Route exact path="/about" 
                  component={About}></Route>
              <Route exact path="/contact" 
                  component={Contact}></Route>
          </Switch> */}
      </AnimatePresence>
  )
}


function App() {

  
  return (
    
    <HashRouter basename='/'>

    <Nav />
    <HeartScene />
    <Animated />

    <Social />

    <Footer/>
<ScrollDown />
{/* <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/work" element={<Work />} />
  <Route path="/about" element={<About />} />
  <Route path="/contact" element={<Contact />} />
  </Routes> */}
</HashRouter>
  )
}

export default App
